module.exports = __webpack_public_path__ + "static/media/Parth-Cv.8ddebba1.pdf";